import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M6.771 9.35a2.738 2.738 0 1 1 5.476 0 2.738 2.738 0 0 1-5.476 0ZM9.51 8.112a1.238 1.238 0 1 0 0 2.476 1.238 1.238 0 0 0 0-2.476Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M20.702 16.94V5.374a2.08 2.08 0 0 0-2.075-2.076H5.374A2.08 2.08 0 0 0 3.3 5.374v13.252a2.08 2.08 0 0 0 2.075 2.075h13.253a2.08 2.08 0 0 0 2.075-2.075V16.94ZM5.374 4.798a.58.58 0 0 0-.575.576v13.252c0 .315.26.575.575.575h.262l3.154-4.725a1.727 1.727 0 0 1 1.163-.75c.508-.093.994.06 1.364.342l.012.01 1.018.812 2.18-3.122a1.75 1.75 0 0 1 2.872.014l.01.014 1.793 2.693V5.374a.58.58 0 0 0-.575-.576H5.374Zm13.828 12.397-3.035-4.558a.261.261 0 0 0-.204-.113.249.249 0 0 0-.207.104l-2.637 3.777a.75.75 0 0 1-1.082.157L10.4 15.256c-.076-.056-.14-.063-.181-.055a.702.702 0 0 1-.03.005.228.228 0 0 0-.144.09l-.006.01-2.6 3.895h11.187a.58.58 0 0 0 .575-.575v-1.43Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  a,
  n
];
function d(r, s) {
  return l(), o("svg", t, [...c]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
